module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_6.6e3099d4.png";